import { render, staticRenderFns } from "./registro.vue?vue&type=template&id=a05315ca&scoped=true"
import script from "./registro.vue?vue&type=script&lang=js"
export * from "./registro.vue?vue&type=script&lang=js"
import style0 from "./registro.vue?vue&type=style&index=0&id=a05315ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05315ca",
  null
  
)

export default component.exports